import Mov from './_mov';

export default class Main {
    constructor() {
        this.mov = new Mov();

        this._init();
    }

    _init() {
        this._registerEvent();
    }

    _registerEvent() {
        window.addEventListener('load', () => document.body.classList.remove('-lock'));
        window.addEventListener('resize', () => this.mov.changeMov());
    }
}
